import axios from "axios";
import router from "@/router";
import { usePermissionStore } from "@/stores/usePermissionStore";

const API_BASE = String(import.meta.env.VITE_API_BASE_URL || '');
if (!API_BASE) throw new Error('Missing VITE_API_BASE_URL'); // fail fast

const api = axios.create({
   baseURL: import.meta.env.VITE_API_BASE_URL,

  headers: {
    "Content-Type": "application/json",
  },
});
// console.log('[API_BASE_URL]', api.defaults.baseURL);

// ✅ Interceptor Request → otomatis set Authorization header
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ✅ Interceptor Response → handle 401 & 403 secara global

// api.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     if (error.response && error.response.status === 401) {
//       console.warn("🔒 Token kadaluarsa atau tidak valid. Auto logout...");

//       // Bersihkan token & redirect manual
//       localStorage.removeItem("token");
//       localStorage.removeItem("user");
//       delete axios.defaults.headers.common["Authorization"];
//       // Pakai cara aman
//       router.push("/login");
//     }

//     return Promise.reject(error);
//   }
// );

// ✅ Interceptor Response → handle 401, 403, dan 419 secara global
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status  = error.response?.status;
    const message = error.response?.data?.message;
    const cfg     = error.config || {};
    const perm    = usePermissionStore();

    // 👉 401 / 419 → token tidak valid, auto logout
    if (status === 401 || status === 419) {
      console.warn("🔒 Token kadaluarsa atau tidak valid. Auto logout...");

      perm.reset?.();
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      delete api.defaults.headers.common.Authorization;

      const current = router.currentRoute.value;
      if (current.name !== "Login") {
        router.replace({ name: "Login", query: { reason: String(status) } });
      }
      return Promise.reject(error);
    }

    // 👉 403 → tidak punya permission, redirect ke dashboard laporan
    if (status === 403 || message === "Anda tidak memiliki izin untuk mengakses resource ini.") {
      const silent403 = cfg?.meta?.silent403 === true;
      if (!silent403) {
        console.warn("🚫 Akses ditolak. Mengarahkan ke halaman dashboard laporan...");
        const current = router.currentRoute.value;
        if (current.name !== "Dashboard") {
          router.replace({ name: "Dashboard" });
        }
      }
      return Promise.reject(error);
    }

    // 👉 selain itu, teruskan error seperti biasa
    return Promise.reject(error);
  }
);



export default api;
